// extracted by mini-css-extract-plugin
export default {"addWarehouseSection":"style_addWarehouseSection__LZCYh","actionsSection":"style_actionsSection__Me1ze","formSection":"style_formSection__fhISH"};